import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fieldsACLFilter',
  pure: false
})

export class FieldsACLFilterPipe implements PipeTransform {

  //transform(value: any, input: string) {
  //  if (input) {

  //    input = input.toLowerCase();

  //    return value.filter(function (obj: any) {
  //      if ((obj.fieldName.toLowerCase().indexOf(input) > -1)) {
  //        return obj
  //      }
  //    })
  //  }
  //  return value;
  //}


  transform(value: any[], input: string, trigger: any):any[] {
    if (!value || !input) {
     return value
    }
    input = input.toLowerCase();
    return value.filter(field => field.fieldName.toLowerCase().indexOf(input) > -1)
  }


}
